// import{checkStatus,parseJSON}from"./responseHandler";const constants=require("./constants");import axios from"axios";export default async(t,s="post",a,e={})=>axios(`${constants.BASE_URL}${t}`,{method:s,data:e,headers:a}).then(checkStatus).then(parseJSON).catch(t=>{throw t});

import axios from "axios";
import { checkStatus, parseJSON } from "./responseHandler";
import { SessionHelper } from './session'
import constants from './constants'
console.log('=constants=', constants)

// Make an api call
export default async(base, url, method = 'post', body) => {
    const content_type = method === 'get' ? '' : 'application/json'
   
    // console.log('==refresh=', SessionHelper.refereshJwtToken())
    return axios(`${base}${url}`, {
            method,
            data: body ? JSON.stringify(body) : null,
            headers: SessionHelper.getHeader(content_type)
        })
        .then(checkStatus)
        .then(parseJSON).catch((err)=>{
            return parseJSON(err.response)
        });
};
 